module.exports = __webpack_public_path__ + "static/media/foam.f1b74c60.png";